import { FormatDate } from '../../../scripts/date-functions';
import { DocumentNode } from "../document-tree-loader";
import { plainToClass } from "class-transformer";
import { EditDocumentModal } from './edit-documents-modal';

export class EditDocumentTreeLoader {
    baseRoute: string = "/api/document-client";
    

    constructor(documentSections: EditDocumentSection[], targetFile: string = "", targetSearchBoxId: string = "") {
        $(() => {

            // Remove quotation character if present
            if (targetFile && targetSearchBoxId) {
                targetFile = targetFile.split("&quot;").join("");
                targetSearchBoxId = targetSearchBoxId.split("&quot;").join("");
            }

            documentSections.forEach(section => {
                if (targetFile && targetSearchBoxId) {
                    this.getDocuments(section, targetFile, targetSearchBoxId);
                }
                else {
                    this.getDocuments(section);
                }
            });

            this.initializeCopyUrl();
        });
    }

    getDocuments(section: EditDocumentSection, targetFile: string = undefined, targetSearchBoxId: string = undefined) {
        let result: any;
        let route = `${this.baseRoute}/get-documents`
        try {
            result = $.ajax(route, {
                method: "GET",
                headers: {
                    "ClientId": section.ClientId
                },
                cache: false,
                success: (nodes) => {
                    if (targetSearchBoxId) {
                        let callbackFn = () => { };
                        if (targetSearchBoxId == `${section.ClientId}-search` && targetFile) {
                            callbackFn = () => {
                                $(`#${section.ClientId}-search`).val(targetFile).trigger("keyup");
                            };
                        }
                        this.drawTree(nodes, section, callbackFn)
                    }
                    else {
                        this.drawTree(nodes, section);
                    }
                }
            });
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    drawTree(nodes: any, section: EditDocumentSection, callbackFn = () => { }) {
        let tree = new EditDocumentTree(nodes, section, callbackFn);
    }

    initializeCopyUrl(): void {
        // ensure no duplicate event listeners
        $("#copy-file-link-btn").off('click');

        $("#copy-file-link-btn").on('click', function () {
            let copyContent = $("#file-copy-id").val().toString();
            navigator.clipboard.writeText(copyContent);
        });

        $('#copy-file-link-btn').popover({
            trigger: 'focus'
        });
    }
}

export class EditDocumentTree {
    baseRoute: string = "/api/document-client";
    section: EditDocumentSection;

    documentTree: any;
    clientId: string;
    label: string;
    treeId: string;
    searchBoxId: string;
    searchClearId: string;
    dateFilterId: string;
    fileDisplayContainerId: string;
    dropdownMenuContainerId: string;
    rootSyncBtnId: string;
    editRootDropdownId: string;
    refreshTreeId: string;
    downloadAnchorId: string;

    syncTreeId: string;
    syncModalId: string;

    imageModalId: string;
    imageTitleId: string;
    imageIframeId: string;
    imageDownloadBtnId: string;

    linkAccountDropdownId: string;
    linkAccountParentId: string;

    toolbarId: string;
    rootFolderBtnId: string;
    rootUploadBtnId: string;

    allNodes: DocumentNode[];

    editDocModal: EditDocumentModal;

    constructor(nodes: any, section: EditDocumentSection, callbackFn = () => { }) {
        this.section = plainToClass(EditDocumentSection, <EditDocumentSection>section);

        this.clientId = this.section.ClientId;
        this.label = this.section.Label;
        this.treeId = `#${this.clientId}-tree`;
        this.searchBoxId = `#${this.clientId}-search`;
        this.searchClearId = `#${this.clientId}-search-clear`;
        this.dateFilterId = `#date-filter-${this.clientId}-tree`;
        this.fileDisplayContainerId = `#file-display-container-${this.clientId}-tree`;
        this.dropdownMenuContainerId = `#dropdown-menu-container-${this.clientId}-tree`;
        this.rootSyncBtnId = `#${this.clientId}-tree-root-sync-btn-group`;
        this.editRootDropdownId = `#${this.clientId}-tree-edit-root-menu`;
        this.refreshTreeId = `#${this.clientId}-tree-refresh-btn`;
        this.syncTreeId = `#${this.clientId}-tree-sync-btn`;
        this.syncModalId = `#sync-documents-modal`;
        this.imageModalId = `#view-image-modal`;
        this.imageTitleId = `#image-filename`;
        this.imageIframeId = `#image-iframe`;
        this.imageDownloadBtnId = `#view-image-download-btn`;
        this.linkAccountDropdownId = `#${this.clientId}-tree-link-account-menu`;
        this.linkAccountParentId = `#${this.clientId}-tree-link-account-parent`;
        this.toolbarId = `#doc-tree-toolbar-${this.clientId}-tree`;
        this.rootFolderBtnId = `#${this.clientId}-tree-root-folder-btn`;
        this.rootUploadBtnId = `#${this.clientId}-tree-root-upload-btn`;
        this.downloadAnchorId = `#non-pdf-link`;


        this.allNodes = plainToClass(DocumentNode, <DocumentNode[]>nodes);
        this.allNodes.forEach(node => node.initializeMerged());

        $(this.searchBoxId).val('');

        // Run the callback function when the document tree is loaded
        $(this.treeId).on("loaded.jstree", () => {
            callbackFn();
        })

        this.createDocumentTree(this.allNodes);

        this.initializeDateFilter();

        if (this.section.IsEditable) {
            this.editDocModal = new EditDocumentModal(this);
        }
    }

    refreshDocuments(targetNodeId: string = undefined): void {
        // Hide Buttons
        $(this.rootSyncBtnId).addClass('d-none');
        $(this.toolbarId).addClass('d-none');

        // Show Loading
        let loadingContent = `
            <div id="${this.clientId}-tree" class="jstree">
                <div class="edit-doc-tree-loading-container">
                    <div class="edit-doc-tree-loading-text">
                        <span class="loading-icon">
                            <i class="fa-solid fa-arrows-rotate"></i>
                        </span>
                        <span class="loading-text">
                            Loading Materials...
                        </span>
                    </div>
                </div>
            </div>
        `

        $(this.fileDisplayContainerId).empty().html(loadingContent);

        // Get Refreshed Documents
        let result: any;
        let route = `${this.baseRoute}/get-documents`
        try {
            result = $.ajax(route, {
                method: "GET",
                headers: {
                    "ClientId": this.clientId
                },
                cache: false,
                success: (nodes) => {
                    // Open Parent Folder of Edited/Added/Deleted Item
                    if (targetNodeId) {
                        $(this.treeId).on("ready.jstree", () => {
                            let tree = $(this.treeId).jstree(true);
                            let node = tree.get_node(targetNodeId);
                            if (node) {
                                tree.select_node(node);
                                if (node?.original?.type == 0) {
                                    tree.open_node(node);
                                }
                            }
                        })
                    }

                    // Create Document Tree
                    this.allNodes = plainToClass(DocumentNode, <DocumentNode[]>nodes);
                    this.allNodes.forEach(node => node.initializeMerged());
                    this.createDocumentTree(this.allNodes);

                    // Show Buttons
                    $(this.rootSyncBtnId).removeClass("d-none");
                    $(this.toolbarId).removeClass('d-none');
                }
            });
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    private async clearDocumentCache(): Promise<boolean> {
        // Get Refreshed Documents
        let result: any;
        let route = `${this.baseRoute}/clear-cache`
        try {
            result = await $.ajax(route, {
                method: "GET",
                headers: {
                    "ClientId": this.clientId
                },
                success: () => {
                    return true;
                }
            });

            return true;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
            return false;
        }
    }

    createDocumentTree(nodes: any): any { 

        this.documentTree = $(this.treeId).jstree({
            "plugins": ["search", "wholerow"],
            "search": {
                "show_only_matches": true,
                "fuzzy": false,
                "search_callback": function (str, node) {
                    let compareTo: string = node.text.toLowerCase();
                    let checkStr: string = str.toLowerCase();

                    if (checkStr.includes("/")) {
                        compareTo = node.id.toLowerCase();
                    }

                    if (compareTo.includes(checkStr)) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
            },
            "types": {
                "folder": {
                    "icon": "fas fa-folder"
                },
                "file": {
                    "icon": "fas fa-file-alt"
                }
            },
            'core': {
                'data': nodes
            }
        });//end jstree


        // When user clicks on a node in the tree 
        let fileTree = this;
        $(this.treeId).on('activate_node.jstree', function (e, data) {
            //if selected node is not a directory, open the file dialog box
            if (data.node.original.type > 0) {
                // check if there are buttons shown for the file
                let targetId = data?.node?.original?.id;
                if (targetId) {
                    let targetEscapedId = $.escapeSelector(targetId);
                    let buttonOptions = $(`#${targetEscapedId}`).find('.file-button-content');
                    // If no buttons, show them
                    if (buttonOptions.length == 0) {
                        fileTree.selectFile(data);
                        fileTree.generateEditButton(data);   
                    }
                }
            }
            // if selected node is a directory, toggle the open/close
            else {
                data.instance.toggle_node(data.node);
            }
        })

        $(this.treeId).on('select_node.jstree', (e, data) => {
            if (data.node.original.type > 0) {
                this.selectFile(data);
                this.generateEditButton(data);

            }
            else {
                this.generateEditButton(data);
                $(this.treeId).find(".file-button-background").remove();
                $(this.treeId).find(".file-button-content").remove();
            }
        });

        $(this.treeId).on('open_node.jstree close_node.jstree', (e, data) => {
            this.generateEditButton(data);
        });

        //do search on keyup
        $(this.searchBoxId).off().on("keyup", function () {
            var search = $(this).val();
            $(fileTree.treeId).jstree('search', search);
        });

        //handle search clear button
        $(this.searchClearId).off().on("click", function () {
            $(fileTree.searchBoxId).val('');
            $(fileTree.treeId).jstree('search', '');
        });


        // Initialize Root Edit Options
        if (this.section.IsEditable) {
            // Show Buttons
            $(this.rootSyncBtnId).removeClass("d-none");
            $(this.toolbarId).removeClass("d-none");
            this.initializeRootMenuOptions();

            // Initialize Refresh & Sync Btn 
            $(this.refreshTreeId).off().on("click", async () => {
                let isCacheRefresh = await this.clearDocumentCache();
                if (isCacheRefresh) {
                    this.refreshDocuments();
                }
            });

            $(this.syncTreeId).off().on("click", () => {
                this.openSyncModal();
            });

            // Initialize Link Account Dropdown
            this.initializeLinkAccountBtn();
        }

        // Display "No Documents" if there are none
        if (nodes.length == 0) {
            let noDocumentsContent = `<p class="px-3 mb-0">No Documents</p>`
            $(this.fileDisplayContainerId).empty().html(noDocumentsContent);
        }
    }

    initializeDateFilter(): void {

        $(this.dateFilterId).selectpicker({
            dropupAuto: false,
            selectedTextFormat: "count"
        });

        $(this.dateFilterId).on("changed.bs.select", () => {
            let selectedVal = $(this.dateFilterId).val().toString();
            let parsedVal = parseInt(selectedVal);
            this.updateDocumentTreeByDate(parsedVal);
        });

    }

    updateDocumentTreeByDate(addDays: number = 0): void {
        // get nodes you want
        let currentNodes = this.allNodes;

        if (addDays != 0) {
            // Set the compare Date
            let currentDate = new Date();
            let compareDate = currentDate;
            compareDate.setTime(compareDate.getTime() - addDays * (24 * 60 * 60 * 1000)); // Converts days to milliseconds
            currentNodes = this.allNodes.filter(node => node.lastModifiedDate.getTime() >= compareDate.getTime() && node.type != 0);

            // Used to determine which folders to add, don't want folders without content
            let currentFolders = this.allNodes.filter(node => node.type == 0);
            let currentFolderNames = [];
            currentNodes.forEach(node => {
                let folderInRoot = false;
                if (node.parent != "#" && !currentFolderNames.includes(node.parent)) {
                    let parentSearch = node.parent;
                    while (folderInRoot == false) {
                        let foundFolder = currentFolders.find(folder => folder.id == parentSearch);
                        if (foundFolder != undefined) {
                            if (!currentFolderNames.includes(foundFolder.id)) {
                                currentFolderNames.push(foundFolder.id);
                                currentNodes.push(foundFolder);
                            }

                            if (foundFolder.parent == "#") {
                                folderInRoot = true; break;
                            }
                            else {
                                parentSearch = foundFolder.parent;
                            }
                        }
                        else {
                            break;
                        }
                    }

                }
            })
            // sort by id
            currentNodes.sort((x1, x2) => {
                // folders come first
                if (x1.type == 0 && x2.type != 0) {
                    return -1;
                }
                else if (x1.type != 0 && x2.type == 0) {
                    return 1;
                }
                return x1.id.localeCompare(x2.id)
            });
        }


        // clear current documents
        $(this.fileDisplayContainerId).html(
            `<div id="${this.clientId}-tree" class="jstree"></div>`
        );

        // create new document tree
        if (currentNodes.length > 0) {
            this.createDocumentTree(currentNodes);
        }
        else {
            $(this.treeId).append(
                `<div class="p-2">No Documents Found</div>`
            )
        }
    }

    openPdfModal(data: any): void {
        // Set Information for dialog box
        var modal = $('#view-document-modal');
        modal.find('#filename').html(data.node.original.text);

        // Add PDF View
        modal.find('#document-iframe').attr('src', data.node.original.link);
        modal.modal('show');

    }

    openCopyLinkModal(data: any): void {
        let modal = $("#share-document-modal");
        modal.find('#filename').html(data.node.original.text);

        let fileId = data.node.original.id;
        if (data.node.original.type == 0) {
            fileId += "/";
        }
        let urlBase = `${window.location.origin}${window.location.pathname}`;
        let copyUrl = `${urlBase}?filename="${encodeURIComponent(fileId)}"&searchid="${encodeURIComponent(this.searchBoxId.replace("#", ""))}"`;
        modal.find("#file-copy-id").val(copyUrl);

        modal.modal('show');
    }
    openImageModal(data: any): void {
        let documentId = data.node.original.id;
        let filePathArr = documentId.split("/");
        let fileName = filePathArr.pop();
        let folderPath = filePathArr.join("/");

        let buttonLink = `${this.baseRoute}/download-file?fileName=${fileName}&folderPath=${folderPath}&clientId=${this.clientId}`;

        $(this.imageDownloadBtnId).attr("href", buttonLink).attr("download", fileName);
        $(this.imageIframeId).attr("src", data.node.original.link);
        $(this.imageTitleId).text(data.node.original.text);
        $(this.imageModalId).modal("show");
    }

    selectFile(data: any) {
        let buttonContent = ""
        // if its in Sharepoint only show the edit in sharepoint button
        if (data.node.original.displaySpLink) {
            buttonContent += `
                <div class="pr-2">
                    <a class="file-btn py-2 font-size13 file-button-download" href="${data.node.original.spLink}" target="_blank" role='button'>Edit in SharePoint <i class="fas fa-external-link-alt"></i></a>
                </div>
            `
        }
        // if PDF or video, add the view button
        else if (data.node.original.link && (data.node.original.type == 1 || data.node.original.type == 6 || data.node.original.type == 5)) {
            buttonContent += `
                <div class="pr-2">
                    <a class="file-btn py-2 font-size13 file-button-view" role="button">View <i class="fa-solid fa-magnifying-glass pl-1"></i></a>
                </div>
            `;
        }
        // URL (open in new tab)
        else if (data.node.original.type == 12) {
            buttonContent += `
                <div class="pr-2">
                    <a class="file-btn py-2 font-size13 file-button-download" href="${data.node.original.link}" target="_blank" role="button">View <i class="fa-solid fa-magnifying-glass pl-1"></i></a>
                </div>
            `;
        }
        // Image
        else if (data.node.original.type == 10) {         
            buttonContent += `
                <div class="pr-2">
                    <a class="file-btn py-2 font-size13 file-button-view-image" role="button">View <i class="fa-solid fa-magnifying-glass pl-1"></i></a>
                </div>
            `;
        }
        // if it has a download link
        else if (!data.node.original.displaySpLink && data.node.original.link) {
            buttonContent += `
                <div class="pr-2">
                    <a class="file-btn py-2 font-size13 file-button-download" href="${data.node.original.link}" download>Download <i class="fa-solid fa-file-arrow-down pl-1"></i></a>
                </div>
            `
        }

        // Always add copy button
        buttonContent += `
            <div class="pr-2">
                <a class="file-btn py-2 font-size13 file-button-copy"  role="button" >Share <i class="fa-solid fa-copy pl-1"></i></a>
            </div>
        `
        

        let selectFileContent = `
            <div class='file-button-background'></div>
            <div class='file-button-content d-flex ml-5 align-items-center justify-content-between'>
                <div class='d-flex pl-1'>
                    ${buttonContent}
                </div>
                <div class='pr-3 file-last-modified-date-content'>
                    <div class='font-size13' style="line-height:20px; font-weight: 500"><u>Last Modified</u></div>
                    <div class='font-size13 text-right' style="line-height:20px;">${FormatDate(data.node.original.lastModifiedDate)}</div>
                </div>
            </div>
        
        `

        // remove any existing buttons
        $(this.treeId).find(".file-button-background").remove();
        $(this.treeId).find(".file-button-content").remove();

        // show the buttons for this file
        $(data.event.currentTarget).after(selectFileContent);

        $(this.treeId).find(".file-button-view").on('click', () => {
            this.openPdfModal(data);
        });

        $(this.treeId).find(".file-button-copy").on('click', () => {
            this.openCopyLinkModal(data);
        })

        $(this.treeId).find(".file-button-view-image").on('click', () => {
            this.openImageModal(data);
        })
    }

    generateEditButton(data: any): void {

        // remove any existing buttons and menus
        $(this.treeId).find(".edit-document-btn").remove();
        $(".edit-document-menu-container").remove();

        let editButton = `
            <a tabindex="0" role="button" class='d-inline-block position-relative edit-document-btn pl-2'>
                <div class="btn-group edit-document-btn-wrapper">
                    <i class="fa-solid fa-ellipsis edit-document-btn-icon"></i>
                </div> 
            </a>
        `;

        let targetId = data?.node?.a_attr?.id;
        if (targetId) {
            // escape special characters ('/', '.', etc)
            let targetEscapedId = $.escapeSelector(targetId);
            $(this.treeId).find(`#${targetEscapedId}`).after(editButton);
        }

        this.initializeMenuOptions(data);
    }

    createEditMenuOptions(data: any): string {
        let docType = data?.node?.original?.type;
        if (docType == null || docType == undefined) return "";

        let isFolder = docType == 0;
        let menuOptions = "";  

        if (isFolder) {
            // Copy Folder
            menuOptions += `<a class="dropdown-item copy-folder-menu-option"><i class="fa-solid fa-copy dropdown-icon pr-2"></i>Copy Link to Folder</a>`;


            if (this.section.IsEditable) {
                menuOptions += "<hr/>"

                // Add Folder
                menuOptions += `<a class="dropdown-item add-folder-menu-option"><i class="fa-solid fa-folder-plus dropdown-icon pr-2"></i>Add New Folder</a>`

                // Add File
                menuOptions += `<a class="dropdown-item add-file-menu-option"><i class="fa-solid fa-file-circle-plus dropdown-icon pr-2"></i>Add New File(s)</a>`

                menuOptions += "<hr/>"

                // Rename Folder
                menuOptions += `<a class="dropdown-item rename-folder-menu-option"><i class="fa-solid fa-pen-to-square dropdown-icon pr-2"></i>Rename Folder</a>`

                // Move Folder
                menuOptions += `<a class="dropdown-item move-folder-menu-option"><i class="fa-solid fa-folder-tree dropdown-icon pr-2"></i>Move Folder</a>`

                menuOptions += "<hr/>"

                // Delete Folder
                menuOptions += `<a class="dropdown-item delete-folder-menu-option"><i class="fa-solid fa-trash-can dropdown-icon pr-2"></i>Delete Folder</a>`
            }

        }
        else {
            // Copy Link
            menuOptions = `<a class="dropdown-item copy-file-menu-option"><i class="fa-solid fa-copy dropdown-icon pr-2"></i>Copy Link to File</a>`

            if (this.section.IsEditable) {
                let isOfficeDocument = false;
                if (docType == 2 || docType == 3 || docType == 4) isOfficeDocument = true;

                menuOptions += "<hr/>"

                // Rename File
                menuOptions += `<a class="dropdown-item rename-file-menu-option"><i class="fa-solid fa-pen-to-square dropdown-icon pr-2"></i>Rename File</a>`

                // Move File
                menuOptions += `<a class="dropdown-item move-file-menu-option"><i class="fa-solid fa-file-export dropdown-icon pr-2"></i>Move File</a>`

                // Collaborative Doc Options
                if (isOfficeDocument && this.section.isMerged()) {
                    menuOptions += `<a class="dropdown-item collab-doc-menu-option"><i class="fa-solid fa-file-signature dropdown-icon pr-2"></i>Collaborative Options</a>`
                }

                menuOptions += "<hr/>"

                // Delete File
                menuOptions += `<a class="dropdown-item delete-file-menu-option"><i class="fa-solid fa-trash-can dropdown-icon pr-2"></i>Delete File</a>`
            }

        }

        return menuOptions;
    }

    initializeMenuOptions(data: any): void {
        // Overflow Issues
        $(this.treeId).find(".edit-document-btn").popover({
            trigger: 'focus',
            html: true,
            content: () => {
                let content = this.createEditMenuOptions(data);
                return content;
            },
            placement: 'right',
            container: this.dropdownMenuContainerId,
            customClass: "edit-document-menu-container"
        });

        $(this.treeId).find(".edit-document-btn").on("shown.bs.popover", () => {
            // Copy Folder/File
            $(this.dropdownMenuContainerId).find(".copy-folder-menu-option, .copy-file-menu-option").on('click', () => {
                this.openCopyLinkModal(data);
            })

            // Add Folder
            $(this.dropdownMenuContainerId).find(".add-folder-menu-option").on('click', () => {
                this.editDocModal.initializeAddNewFolder(data);
            })

            // Add File
            $(this.dropdownMenuContainerId).find(".add-file-menu-option").on("click", () => {
                this.editDocModal.initializeAddNewFile(data);
            })

            // Rename Folder
            $(this.dropdownMenuContainerId).find(".rename-folder-menu-option").on("click", () => {
                this.editDocModal.initalizeRenameFolder(data);
            })

            // Rename File
            $(this.dropdownMenuContainerId).find(".rename-file-menu-option").on("click", () => {
                this.editDocModal.initializeRenameFile(data);
            })

            // Delete Folder
            $(this.dropdownMenuContainerId).find(".delete-folder-menu-option").on("click", () => {
                this.editDocModal.initializeDeleteFolder(data);
            })

            // Delete File
            $(this.dropdownMenuContainerId).find(".delete-file-menu-option").on('click', () => {
                this.editDocModal.initializeDeleteFile(data);
            })

            // Move Folder
            $(this.dropdownMenuContainerId).find(".move-folder-menu-option").on("click", () => {
                let folderNodes = this.allNodes.filter(node => node.type == 0);
                this.editDocModal.initializeMoveFolder(data, folderNodes);
            })

            // Move File
            $(this.dropdownMenuContainerId).find(".move-file-menu-option").on('click', () => {
                let folderNodes = this.allNodes.filter(node => node.type == 0);
                this.editDocModal.initializeMoveFile(data, folderNodes);
            })

            // Collab Doc Options
            $(this.dropdownMenuContainerId).find(".collab-doc-menu-option").on('click', () => {
                this.editDocModal.iniializeCollabDocUpdate(data);
            })
        })
      
    }

    initializeRootMenuOptions(): void {
        $(this.rootFolderBtnId).off().on("click", () => {
            this.editDocModal.initializeAddNewRootFolder();
        });

        $(this.rootUploadBtnId).off().on("click", () => {
            this.editDocModal.initializeAddNewRootFile();
        });


        let menuOptions = "";

        // Add Folder To Root
        menuOptions += `<a class="dropdown-item add-root-folder-menu-option"><i class="fa-solid fa-folder-plus dropdown-icon pr-2"></i>Add Folder to Root</a>`

        // Add File To Root
        menuOptions += `<a class="dropdown-item add-root-file-menu-option"><i class="fa-solid fa-file-circle-plus dropdown-icon pr-2"></i>Add File(s) to Root</a>`

        $(this.editRootDropdownId).empty().html(menuOptions);

        $(this.editRootDropdownId).find(".add-root-folder-menu-option").off().on("click", () => {
            this.editDocModal.initializeAddNewRootFolder();
        });

        $(this.editRootDropdownId).find(".add-root-file-menu-option").off().on("click", () => {
            this.editDocModal.initializeAddNewRootFile();
        });
    }

    initializeDocumentSyncBtn(): void {
        $(this.syncModalId).find(`#${this.clientId}-sync-button`).on("click", async () => {
            let isValid: boolean = await this.validateSPToken();

            if (!isValid) return;

            let documentUpdates = await this.getSyncUpdates();

            let updateCount = Object.keys(documentUpdates).length;
            this.showSyncProgress(updateCount);

            let errorArr: string[] = [];

            // update sync modal with progress bar
            let updatesComplete: number = 0;
            for (const key in documentUpdates) {
                if (documentUpdates.hasOwnProperty(key)) {
                    let documentId = key;
                    let updateType = documentUpdates[key]

                    let percentComplete = Math.round((updatesComplete / updateCount) * 100);
                    this.updateSyncProgress(updatesComplete, percentComplete, documentId);

                    let result = await this.syncDocument(documentId, updateType);
                    if (result) {
                        errorArr.push(result);
                    }
                    updatesComplete += 1;
                }
            }

            // show complete
            if (errorArr.length == 0) {
                this.showSyncProgress();
                this.refreshDocuments();
                setTimeout(() => {
                    $(this.syncModalId).modal('hide');
                }, 1500)
            }
            else {
                this.showSyncErrors(errorArr);
            };
        })
    }
    initializeLinkAccountBtn(): void {
        let loadingDisplay = `<h6 class="dropdown-header invisible"><i class="fa-solid fa-circle-check success-icon pr-3"></i>No SharePoint Account Linked</h6>`

        $(this.linkAccountParentId).off("show.bs.dropdown").on("show.bs.dropdown", async () => {
            $(this.linkAccountDropdownId).empty().html(loadingDisplay);

            let route = `${this.baseRoute}/user-sp-auth`;
            let logoutLinkRoute = `${this.baseRoute}/user-sp-logout-link`;
            let logoutRoute = `${this.baseRoute}/user-sp-logout`;

            try {
                let result: string = await $.ajax(route, {
                    method: "GET",
                    cache: false
                });

                let content = "";
                let logoutLink = "";
                if (result) {
                    content = `<h6 class="dropdown-header">No SharePoint Account Linked<i class="fa-solid fa-circle-xmark error-icon pl-3"></i></h6><hr>`
                    content += `<a class="dropdown-item link-account-menu-option"><i class="fa-solid fa-circle-user dropdown-icon pr-2"></i>Link SP Account</a>`
                }
                else {                 
                    let logoutLinkResult: string = await $.ajax(logoutLinkRoute, {
                        method: "GET",
                        cache: false
                    });
                    content = `<h6 class="dropdown-header">SharePoint Account Linked<i class="fa-solid fa-circle-check success-icon pl-3"></i></h6><hr>`
                    content += `<a class="dropdown-item logout-account-menu-option"><i class="fa-solid fa-circle-user dropdown-icon pr-2"></i>Logout SP Account</a>`
                    logoutLink = logoutLinkResult;
                }
                $(this.linkAccountDropdownId).empty().html(content);

                $(this.linkAccountDropdownId).find(".link-account-menu-option").on("click", () => {
                    window.open(result, "_blank", "popup");
                })

                $(this.linkAccountDropdownId).find(".logout-account-menu-option").on("click", async () => {
                    if (logoutLink) {
                        // Removes any stored cookies
                        let logoutResult: string = await $.ajax(logoutRoute, {
                            method: "GET",
                            cache: false
                        });

                        window.open(logoutLink, "_blank", "popup");
                    }
                })
            }
            catch (error) {
                alert("An error has occurred, please refresh the page and try again.");
                console.log(error);
            }

            // Adjust Dropdown postion to fit correct size
            setTimeout(() => {
                $(this.linkAccountParentId).find(".dropdown-toggle").dropdown("update");
            }, 10);
        })
    }

    async getSyncUpdates(): Promise<Object> {
        // Update display
        let content = `
            <div class="text-center py-5 mt-5 mb-3">
                <div class="edit-doc-saving">
                    <div class="edit-doc-saving-text text-center pb-1 font-size20 font-weight-500">Looking for Updates</div>
                    <div class="edit-doc-loader d-flex justify-content-center">
                        <div class="loader"></div>
                    </div>
                </div>
            </div>
        `

        $(this.syncModalId).find(".modal-header").addClass("d-none");
        $(this.syncModalId).find(".modal-body").empty().html(content);

        // Get Refreshed Documents
        let result: any;
        let route = `${this.baseRoute}/get-document-updates`
        try {
            result = await $.ajax(route, {
                method: "GET",
                headers: {
                    "ClientId": this.clientId
                }
            });
            let documentUpdates: Object = result;
            return documentUpdates;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
            return { };
        }
    }

    async syncDocument(documentId: string, updateType: string): Promise<string> {
        // update documents in S3
        let result: string;
        let route = `${this.baseRoute}/update-synced-document`

        let requestBody = {
            documentId: documentId,
            updateType: updateType
        }

        try {
            result = await $.ajax(route, {
                method: "POST",
                headers: {
                    "ClientId": this.clientId
                },
                data: JSON.stringify(requestBody),
                contentType: "application/json; charset=utf-8",
                dataType: "text"
            });
            if (result == "OK") {
                return "";
            }
            else if (result.includes("Exceeds")) {
                let fileArr = documentId.split("/");
                let fileName = fileArr.pop();
                return `${fileName}|Large File (> 50MB)`;
            }
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
            return "";
        }
    }

    openSyncModal(): void {
        let header = `<div class="edit-doc-header mb-2">Document Sync</div>`
        let userInput = `
            <div class="mt-3 edit-doc-modal-form">
                <p class="sm-text-block">Use the sync button below to sync any changes that have occurred in SharePoint/Teams with the Portal. This is only needed if documents or folders have been created, modified, or moved directly in SharePoint/Teams.</p>
                <div class="mt-4 d-flex">
                    <button type="button" class="btn edit-doc-btn px-3" id="${this.clientId}-sync-button">
                        <i class="fa-solid fa-arrows-rotate pr-2"></i> Sync
                    </button>
                    <button type="button" class="btn edit-doc-btn edit-doc-light-btn ml-3 px-3" id="${this.clientId}-close-sync-modal">
                        Close
                    </button>
                </div>
            </div>
        `
        let html = `
            ${header}
            <hr class="my-3">
            ${userInput}
        `

        $(this.syncModalId).find(".modal-header").removeClass("d-none");
        $(this.syncModalId).find(".modal-body").empty().html(html);

        this.initializeDocumentSyncBtn();

        $(this.syncModalId).find(`#${this.clientId}-close-sync-modal`).on("click", () => {
            $(this.syncModalId).modal("hide");
        })

        $(this.syncModalId).modal('show');

    }

    showSyncProgress(documentUpdateCount: number = 0): void {
        let modalBody = $(this.syncModalId).find(".modal-body");

        if (documentUpdateCount < 1) {
            let content = `
                <div class="text-center py-5 mt-5 mb-3">
                    <div class="edit-doc-saving">
                        <div class="edit-doc-saving-text text-center pb-1 font-size20 font-weight-500">Documents Synced!</div>
                    </div>
                </div>
            `

            modalBody.empty().html(content);
        }
        else {
            let displayText = "Updates";
            if (documentUpdateCount == 1) displayText = "Update";

            let content = `
                <div class="text-center py-5 mt-5 mb-3">
                    <div class="edit-doc-saving">
                        <div class="edit-doc-saving-text text-center pb-1 font-size20 font-weight-500">${documentUpdateCount.toString()} ${displayText} Found (<span class="completed-sync-count">0</span>/${documentUpdateCount.toString()})</div>
                        <div class="edit-doc-loader d-flex justify-content-center">
                            <div class="loader no-animation"></div>
                        </div>
                        <div class="sync-progress-text text-center mt-2">
                            <span class="loading-icon">
                                <i class="fa-solid fa-arrows-rotate"></i>
                            </span>
                            <span class="loading-text"></span>
                        </div>
                    </div>
                </div>
            `

            modalBody.empty().html(content);
        }
    }

    showSyncErrors(errorArr: string[]) {
        let modalBody = $(this.syncModalId).find(".modal-body");

        let displayText = "Documents";
        if (errorArr.length == 1) displayText = "Document";

        let header = `<div class="edit-doc-header mb-2">${errorArr.length} ${displayText} Not Synced</div>`
        let userInput = `
            <div class="mt-3 mb-4 edit-doc-modal-form">
                <p class="sm-text-block">Some documents were not able to be synced due to their file size. <u>These documents will be automatically synced with the portal tonight at 12am EST</u>.</p>
                <p class="sm-text-block">If these files need to be immediately synced with the portal, use the 'Force Sync' button below. This sync will take several minutes to complete, and the documents displayed on this page will be refreshed after the sync completes.</p>
                <div class="mt-4 d-flex" id="${this.clientId}-force-sync-btn-container">
                    <button type="button" class="btn edit-doc-btn px-3" id="${this.clientId}-force-sync-button">
                        <i class="fa-solid fa-arrows-rotate pr-2"></i> Force Sync
                    </button>
                    <button type="button" class="btn edit-doc-btn edit-doc-light-btn ml-3 px-3" id="${this.clientId}-close-sync-modal">
                        Close
                    </button>
                </div>
            </div>
        `
        let content = `
            ${header}
            <hr class="my-3">
            ${userInput}
        `

        let errorContent = "";
        errorArr.forEach(err => {
            let errorSplit = err.split("|");
            if (errorSplit.length == 2) {
                let fileName = errorSplit[0];
                let errorDescription = errorSplit[1];

                let errorBlock = `<li class="mb-1">${fileName}</li>`;

                errorContent += errorBlock;
            }
        });

        content += `
            <div class="error-content-list">
                <div class="error-block no-animation">
                    <div class="d-flex align-items-center">
                        <div class="pr-2 error-icon"><i class="fa-solid fa-circle-xmark fa-lg"></i></div>
                        <div class="error-text">
                            <ul class="mb-0">
                                ${errorContent}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        `

        $(this.syncModalId).find(".modal-header").removeClass("d-none");
        modalBody.empty().html(content);

        $(modalBody).find(`#${this.clientId}-force-sync-button`).on("click", async () => {
            // Show Sync Loading
            let modalHeader = $(this.syncModalId).find(".modal-header");
            let modalBody = $(this.syncModalId).find(".modal-body");
            modalHeader.addClass("d-none");

            let content = `
                <div class="text-center py-5 mt-5 mb-3">
                    <div class="edit-doc-saving">
                        <div class="edit-doc-saving-text text-center pb-1 font-size20 font-weight-500">Initiating Sync</div>
                        <div class="edit-doc-loader d-flex justify-content-center">
                            <div class="loader"></div>
                        </div>
                    </div>
                </div>
            `

            modalBody.empty().html(content);

            let result = await this.forceSync();
            if (result) {
                console.log(result);
            }

            let successContent = `
                <div class="text-center py-5 mt-5 mb-3">
                    <div class="edit-doc-saving">
                        <div class="edit-doc-saving-text text-center pb-1 font-size20 font-weight-500">Sync Initiated</div>
                    </div>
                </div>
            `
            modalBody.empty().html(successContent);

            setTimeout(() => {
                $(this.syncModalId).modal("hide");
            }, 1500)
        })

        $(modalBody).find(`#${this.clientId}-close-sync-modal`).on("click", () => {
            console.log("Close Modal Button Triggered!");
            $(this.syncModalId).modal("hide");
        })
    }

    updateSyncProgress(numberComplete: number, percentComplete: number, documentId: string) {
        let loadingBar = $(this.syncModalId).find(".loader");
        let progressText = $(this.syncModalId).find(".sync-progress-text").find(".loading-text");
        let completedCount = $(this.syncModalId).find(".completed-sync-count");

        loadingBar.css({
            "background-size": `${percentComplete.toString()}%`
        });

        let filePathArr = documentId.split("/");
        let fileName = filePathArr.pop();

        progressText.text(`Updating ${fileName}...`);

        completedCount.text(numberComplete.toString());
    }

    async forceSync(): Promise<string> {
        // force appflow sync
        let result: string;
        let route = `${this.baseRoute}/force-sync-appflow`

        try {
            result = await $.ajax(route, {
                method: "POST",
                headers: {
                    "ClientId": this.clientId
                },
                dataType: "text"
            });
            if (result == "OK") {
                return "";
            }
            else {
                console.log(result);
                return `${result}`;
            }
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
            return "";
        }
    }

    // Validate SP Token 
    private async validateSPToken(): Promise<boolean> {
        let route = "/api/document-client/user-sp-auth"
        let result: string = await $.ajax(route, {
            method: "GET"
        });

        if (result) {
            window.open(result, "_blank", "popup");
            return false;
        }

        return true;
    }

}

export class EditDocumentSection {
    Label: string;
    ClientId: string;
    ClientType: number;
    IsEditable: boolean;

    constructor() { };

    isSynced(): boolean {
        if (this.ClientType == 3) return true;
        return false;
    }

    isMerged(): boolean {
        if (this.ClientType == 2) return true;
        return false;
    }

    isSharePoint(): boolean {
        if (this.ClientType == 0) return true;
        return false;
    }

    isS3(): boolean {
        if (this.ClientType == 1) return true;
        return false;
    }
}
